export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.67986 2.05339C8.98357 1.952 9.31785 1.99657 9.58339 2.17387L15.1449 5.88713L20.6457 4.05072C20.9588 3.94621 21.3037 3.99695 21.5723 4.18703C21.8408 4.37711 22.0001 4.68323 22.0001 5.00933V18.9907C22.0001 19.4246 21.7197 19.8102 21.3032 19.9493L15.3202 21.9466C15.0165 22.048 14.6822 22.0034 14.4167 21.8261L8.85524 18.1129L3.35436 19.9493C3.0413 20.0538 2.69637 20.003 2.42782 19.813C2.15926 19.6229 2 19.3168 2 18.9907V5.00933C2 4.57541 2.28036 4.18979 2.69693 4.05072L8.67986 2.05339ZM4.05129 5.73526V17.5799L7.98291 16.2674V4.42274L4.05129 5.73526ZM13.9658 19.0813L10.0342 16.4562V4.91868L13.9658 7.54374V19.0813ZM16.0171 19.5773L19.9488 18.2647V6.42006L16.0171 7.73262V19.5773Z"
      fill="currentColor"
    />
  </svg>
);
